export default __webpack_public_path__ + "static/media/IMG_4689.490e528e.JPG";